"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_VARIANTS = exports.BUTTON_TEXT_SIZES = exports.BUTTON_STYLES = exports.BUTTON_SIZES = void 0;
var _types = require("./types");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DEFAULT_PRIMARY_STATES = {
  focus: {
    backgroundColor: "blue100",
    borderColor: "blue100",
    color: "white100",
    textDecoration: "underline"
  },
  hover: {
    backgroundColor: "blue100",
    borderColor: "blue100",
    color: "white100",
    textDecoration: "underline"
  },
  active: {
    backgroundColor: "blue150",
    borderColor: "blue150",
    color: "white100",
    textDecoration: "underline"
  },
  loading: {
    backgroundColor: "blue100",
    borderColor: "blue100",
    color: "white100"
  },
  disabled: {
    backgroundColor: "black30",
    borderColor: "black30",
    color: "white100"
  },
  success: {
    backgroundColor: "blue100",
    borderColor: "blue100",
    color: "white100"
  }
};
var DEFAULT_SECONDARY_STATES = _objectSpread(_objectSpread({}, DEFAULT_PRIMARY_STATES), {}, {
  disabled: {
    backgroundColor: "transparent",
    borderColor: "black30",
    color: "black30"
  }
});
var BUTTON_STYLES = {
  primaryBlack: _objectSpread({
    default: {
      backgroundColor: "black100",
      borderColor: "black100",
      color: "white100"
    }
  }, DEFAULT_PRIMARY_STATES),
  primaryWhite: _objectSpread({
    default: {
      backgroundColor: "white100",
      borderColor: "white100",
      color: "black100"
    }
  }, DEFAULT_PRIMARY_STATES),
  primaryBlue: _objectSpread(_objectSpread({
    default: {
      backgroundColor: "blue100",
      borderColor: "blue100",
      color: "white100"
    }
  }, DEFAULT_PRIMARY_STATES), {}, {
    focus: {
      backgroundColor: "blue150",
      borderColor: "blue150",
      color: "white100",
      textDecoration: "underline"
    },
    hover: {
      backgroundColor: "blue150",
      borderColor: "blue150",
      color: "white100",
      textDecoration: "underline"
    },
    active: {
      backgroundColor: "#050e3e",
      // Unique color to this state
      borderColor: "#050e3e",
      // Unique color to this state
      color: "white100",
      textDecoration: "underline"
    }
  }),
  primaryGray: _objectSpread({
    default: {
      backgroundColor: "black10",
      borderColor: "black10",
      color: "black100"
    }
  }, DEFAULT_PRIMARY_STATES),
  secondaryBlack: _objectSpread({
    default: {
      backgroundColor: "transparent",
      borderColor: "black100",
      color: "black100"
    }
  }, DEFAULT_SECONDARY_STATES),
  secondaryBlue: _objectSpread({
    default: {
      backgroundColor: "transparent",
      borderColor: "blue100",
      color: "blue100"
    }
  }, DEFAULT_SECONDARY_STATES),
  secondaryWhite: _objectSpread({
    default: {
      backgroundColor: "transparent",
      borderColor: "white100",
      color: "white100"
    }
  }, DEFAULT_SECONDARY_STATES),
  /** Used for follow buttons */
  secondaryNeutral: _objectSpread(_objectSpread({
    default: {
      backgroundColor: "transparent",
      borderColor: "black100",
      color: "black100"
    }
  }, DEFAULT_SECONDARY_STATES), {}, {
    focus: {
      backgroundColor: "black10",
      borderColor: "black10",
      color: "black100",
      textDecoration: "underline"
    },
    hover: {
      backgroundColor: "black100",
      borderColor: "black100",
      color: "white100",
      textDecoration: "underline"
    },
    active: {
      backgroundColor: "black100",
      borderColor: "black100",
      color: "white100",
      textDecoration: "underline"
    },
    loading: {
      backgroundColor: "black100",
      borderColor: "black100",
      color: "white100"
    },
    success: {
      backgroundColor: "transparent",
      borderColor: "black100",
      color: "black100"
    }
  }),
  tertiary: {
    default: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black100"
    },
    focus: {
      backgroundColor: "blue10",
      borderColor: "blue10",
      color: "blue100",
      textDecoration: "underline"
    },
    hover: {
      backgroundColor: "blue10",
      borderColor: "blue10",
      color: "blue100",
      textDecoration: "underline"
    },
    active: {
      backgroundColor: "#cacdec",
      // Unique color to this state
      borderColor: "#cacdec",
      // Unique color to this state
      color: "blue100",
      textDecoration: "underline"
    },
    loading: {
      backgroundColor: "blue10",
      borderColor: "blue10",
      color: "blue100"
    },
    disabled: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black30"
    },
    success: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "blue100"
    }
  }
};
exports.BUTTON_STYLES = BUTTON_STYLES;
/** Inverts the structure of the style object so that we can use responsive values for `variant` */
var BUTTON_VARIANTS = _types.BUTTON_STATES.reduce(function (variantsMemo, state) {
  return _objectSpread(_objectSpread({}, variantsMemo), {}, _defineProperty({}, state, _types.BUTTON_VARIANT_NAMES.reduce(function (stateMemo, variant) {
    return _objectSpread(_objectSpread({}, stateMemo), {}, _defineProperty({}, variant, BUTTON_STYLES[variant][state]));
  }, {})));
}, {});

/** Available button sizes */
exports.BUTTON_VARIANTS = BUTTON_VARIANTS;
var BUTTON_SIZES = {
  small: {
    height: "30px",
    borderRadius: "15px",
    px: "25px"
  },
  large: {
    height: "50px",
    borderRadius: "25px",
    px: "25px"
  }
};

/** Text sizes associated with available button sizes */
exports.BUTTON_SIZES = BUTTON_SIZES;
var BUTTON_TEXT_SIZES = {
  small: "xs",
  large: "sm-display"
};
exports.BUTTON_TEXT_SIZES = BUTTON_TEXT_SIZES;
//# sourceMappingURL=tokens.js.map